import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { Modal, ModalProps, ModalWrapper } from '@shared/ui/organisms';
import { withTheme } from '@shared/lib/theme';
import ModalContent from './ModalContent';
type RegionsWithRestrictionsIntructionModalDesktopProps = ModalProps;
const RegionsWithRestrictionsIntructionModalDesktop: FC<RegionsWithRestrictionsIntructionModalDesktopProps> = ({
  open,
  onClose
}) => <Modal mobile open={open} onClose={onClose}>
    <ModalWrapper>
      <ContentWrapper>
        <ModalContent onClose={onClose} />
      </ContentWrapper>
    </ModalWrapper>
  </Modal>;
export default RegionsWithRestrictionsIntructionModalDesktop;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const ContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "ch1iwmy",
  propsAsIs: false,
  vars: {
    "ch1iwmy-0": [_exp()]
  }
}));

require("./RegionsWithRestrictionsIntructionModalDesktop.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./RegionsWithRestrictionsIntructionModalDesktop.tsx");